/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
import {useEffect, useRef, useState, useMemo} from 'react'
import {DateRangePickerField, SelectSearchField} from '../../components'
import {initialQueryRequest} from './core/crud-helper'
import {useQueryRequest} from './core/QueryRequestProvider'
import {useQueryResponse} from './core/QueryResponseProvider'
import {globalDropdown} from './core/_models'
import {getFilterOptions, getProjectOptions} from './core/_requests'

export default function PortfolioFilter() {
  const dateref = useRef<any>()
  const endaProtected = useMemo(
    () => [
      {
        id: 1,
        name: 'Yes',
      },
      {
        id: 0,
        name: 'No',
      },
    ],
    []
  )
  const [isProjectLoading, setIsProjectLoading] = useState(false)
  const [showDateRangePicker, setShowDateRangePicker] = useState(false)
  const [clientList, setClientList] = useState<globalDropdown[]>([])
  const [projectList, setProjectList] = useState<globalDropdown[]>([])
  const [defaultProjectList, setDefaqultProjectList] = useState<any>([])
  const [technology, setTechnology] = useState<globalDropdown[]>([])
  const [framework, setFramework] = useState<globalDropdown[]>([])
  const [service, setService] = useState<globalDropdown[]>([])
  const [industry, setIndustry] = useState<globalDropdown[]>([])
  const [urlStatus] = useState<any[]>([
    {
      id: 'Live',
      name: 'Live',
    },
    {
      id: 'Draft',
      name: 'Draft',
    },
    {
      id: 'Private',
      name: 'Private',
    },
    {
      id: 'Archived',
      name: 'Archived',
    },
  ])
  const [ndaProtected, setNDAProtected] = useState<globalDropdown[]>([])
  const [state, setState] = useState<any>({
    selectionRange: {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
    projectName: '',
    eNDAProtected: {
      id: 0,
      name: 'No',
    },
    clientList: [],
    technology: [],
    framework: [],
    service: [],
    industry: [],
    urlStatus: [],
    project: [],
  })
  const [initaialLoading, setInitialLoading] = useState(true)
  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()

  let fetchProjectsController: AbortController | null = null
  let fetchProjectsDebounceTimer: ReturnType<typeof setTimeout> | null = null
  let projectSearchController: AbortController | null = null

  // Show only loader initial level
  useEffect(() => {
    if (initaialLoading && !isLoading) {
      setInitialLoading(false)
    }
  }, [isLoading, initaialLoading])

  useEffect(() => {
    let handler = (e: any) => {
      if (!dateref.current.contains(e.target)) {
        setShowDateRangePicker(false)
      }
    }
    document.addEventListener('mouseup', handler)
    return () => {
      document.removeEventListener('mouseup', handler)
    }
  }, [])

  useEffect(() => {
    getFilterOptions()
      .then((response) => {
        if (response.status === 200) {
          setClientList(response.data.client)
          setTechnology(response?.data?.technology)
          setFramework(response?.data?.framework)
          setService(response?.data?.service)
          setIndustry(response?.data?.industry)
          // setUrlstatus(response?.data?.urlStatus)
          setProjectList(response?.data?.project)
          setDefaqultProjectList(response?.data?.project)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  useEffect(() => {
    setNDAProtected(endaProtected)
  }, [endaProtected])

  useEffect(() => {
    onSubmit(state)
  }, [state])

  const handleOnSelect = (ranges: any) => {
    let tempState = {...state}
    tempState.selectionRange = ranges.selection
    setState(tempState)
    setShowDateRangePicker(false)
  }

  const fetchProjectsByClientIds = (ids: any[]) => {
    if (fetchProjectsDebounceTimer) {
      clearTimeout(fetchProjectsDebounceTimer)
    }

    fetchProjectsDebounceTimer = setTimeout(async () => {
      if (fetchProjectsController) {
        fetchProjectsController.abort()
      }

      fetchProjectsController = new AbortController()
      const {signal} = fetchProjectsController

      setIsProjectLoading(true)

      try {
        const payload = ids.length > 0 ? {clientId: ids} : {}

        const response = await getProjectOptions(payload, {signal})

        setProjectList(response.data)
      } catch (error: any) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          return
        }

        console.error(error)
      } finally {
        setIsProjectLoading(false)
      }
    }, 1000)
  }

  const handleOnChange = (event: any) => {
    const name = event.target.name
    const value = event.target.value
    // setIsProjectLoading(true)

    let tempState = {
      ...state,
      [name]: value,
      ...(name === 'clientList' && {projectName: null}),
    }

    if (name === 'clientList') {
      if (value && value.length > 0) {
        const validClientIds = new Set(value.map((c: any) => c.id))
        const currentProjects = state.project || []

        const filteredProjects = currentProjects.filter((p: any) => {
          const clientId = p.clientId || p.client_id || (p.client && p.client.id)
          return validClientIds.has(clientId)
        })

        tempState.project = filteredProjects

        const ids = value.map((item: any) => item.id)

        fetchProjectsByClientIds(ids)
      } else {
        tempState.project = []
        setProjectList(defaultProjectList)
      }
    } else if (name === 'project') {
      const selectedProjects = value || []
      const currentClientIds = new Set(state.clientList?.map((c: any) => c.id) || [])
      const newClients = [...(state.clientList || [])]
      let isClientChanged = false

      selectedProjects.forEach((p: any) => {
        const clientId = p.clientId || p.client_id || (p.client && p.client.id)

        if (clientId && !currentClientIds.has(clientId)) {
          // Use loose equality (==) for the find to handle string vs number mismatches
          const client = clientList.find((c: any) => c.id == clientId)

          if (client) {
            newClients.push(client)
            currentClientIds.add(clientId)
            isClientChanged = true
          } 
        }
      })

      if (isClientChanged) {
        tempState.clientList = newClients
        const ids = newClients.map((item: any) => item.id)
        fetchProjectsByClientIds(ids)
      }
    }

    setState(tempState)
  }

  const debounceRef = {current: null as any}

  const searchProjects = (inputValue: string) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    debounceRef.current = setTimeout(async () => {
      if (projectSearchController) {
        projectSearchController.abort()
      }

      projectSearchController = new AbortController()
      const {signal} = projectSearchController

      setIsProjectLoading(true)

      try {
        const data = {
          searchText: inputValue,
        }

        const response: any = await getProjectOptions(data, {signal})

        if (response?.status === 200) {
          setProjectList(response.data)
        } else {
          setProjectList([])
        }
      } catch (error: any) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          return
        }

        console.error('Project search failed:', error)
      } finally {
        setIsProjectLoading(false)
      }
    }, 1000)
  }

  const onSubmit = (state: any) => {
    const client = state.clientList ? state.clientList?.map((item: any) => item.id) : []
    const urlStatus = state.urlStatus ? state.urlStatus?.map((item: any) => item.id) : []
    const technology = state.technology ? state.technology?.map((item: any) => item.id) : []
    const framework = state.framework ? state.framework?.map((item: any) => item.id) : []
    const service = state.service ? state.service?.map((item: any) => item.id) : []
    const industry = state.industry ? state.industry?.map((item: any) => item.id) : []
    const project = state.project ? state.project?.map((item: any) => item.id) : []

    updateState({
      ...initialQueryRequest.state,
      filter: {
        projectName: state && state.projectName ? state.projectName : null,
        dateFrom: state.selectionRange.startDate
          ? moment(state.selectionRange.startDate).format('YYYY-MM-DD')
          : null,
        dateTo: state.selectionRange.endDate
          ? moment(state.selectionRange.endDate).format('YYYY-MM-DD')
          : null,
        clientId: client && client.length > 0 ? client : null,
        technology: technology && technology.length > 0 ? technology : null,
        industry: industry && industry.length > 0 ? industry : null,
        service: service && service.length > 0 ? service : null,
        framework: framework && framework.length > 0 ? framework : null,
        url_status: urlStatus && urlStatus.length > 0 ? urlStatus : null,
        project: project && project.length > 0 ? project : null,
        eNDAProtected: state.eNDAProtected ? state.eNDAProtected.id.toString() : null,
      },
    })
  }

  const resetFilter = () => {
    setProjectList(defaultProjectList)

    setState({
      selectionRange: {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
      projectName: '',
      clientList: [],
      technology: [],
      industry: [],
      framework: [],
      service: [],
      urlStatus: '',
      eNDAProtected: {
        id: 0,
        name: 'No',
      },
      project: [],
    })
    updateState({
      filter: {
        projectName: null,
        dateFrom: null,
        dateTo: null,
        clientList: null,
        technology: null,
        industry: null,
        framework: null,
        service: null,
        url_status: null,
        eNDAProtected: '0',
        project: null,
      },
      ...initialQueryRequest,
    })
  }

  return (
    <div className='card'>
      <div className='card-body p-4'>
        <div className='col-md-12'>
          <form
            className='form'
            noValidate
            // onSubmit={(e) => onSubmit(e)}
          >
            <div className='fv-row row align-items-center mb-2'>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>Clients</label>
                <SelectSearchField
                  value={state.clientList}
                  options={clientList}
                  isSearchable={true}
                  name='clientList'
                  isLoading={false}
                  loadingMessage='Featching clients'
                  noOptionsMessage='Clients are not available.'
                  placeholder='Select client'
                  handleOnChange={handleOnChange}
                  multiple={true}
                />
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>Project</label>
                <SelectSearchField
                  dynamicListLoading={true}
                  value={state.project}
                  options={projectList}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  handleInputChange={(inputVal: any, actionMeta: any) => {
                    if (actionMeta.action !== 'input-change') {
                      return
                    }

                    setIsProjectLoading(true)

                    if (inputVal?.length > 0) {
                      searchProjects(inputVal)
                    } else {
                      if (state?.clientList?.length > 0) {
                        const ids = state?.clientList?.map((item: any) => item.id)
                        fetchProjectsByClientIds(ids)
                      } else {
                        setIsProjectLoading(false)
                        setProjectList(defaultProjectList)
                      }
                    }
                  }}
                  loadOptions={(inputValue: any) => searchProjects(inputValue)}
                  name='project'
                  isLoading={isProjectLoading}
                  loadingMessage='Fetching Projects ...'
                  noOptionsMessage='Project are not available.'
                  placeholder='Select Project Name'
                  multiple={true}
                  isProjectField={true}
                  isClientShowInProject={true}
                  isResourceNeedToShow={true}
                />
              </div>
              <div
                className='col-12 col-md-6 col-lg-3 px-2 pb-3 date-range-picker-parent'
                ref={dateref}
              >
                <label className='fw-bold fs-6 mb-2'>Start date</label>
                <input
                  className='form-control'
                  type='text'
                  name='startDate'
                  autoComplete='off'
                  onChange={() => setShowDateRangePicker(!showDateRangePicker)}
                  value={
                    state.selectionRange.startDate && state.selectionRange.endDate
                      ? `${moment(state.selectionRange.startDate).format(
                          'DD-MMM-YYYY'
                        )}  -  ${moment(state.selectionRange.endDate).format('DD-MMM-YYYY')}`
                      : ''
                  }
                  onClick={() => setShowDateRangePicker(!showDateRangePicker)}
                  placeholder='Start date'
                />
                {showDateRangePicker && (
                  <DateRangePickerField
                    selectionRange={state.selectionRange}
                    handleOnSelect={handleOnSelect}
                    className={'timelog-daterange'}
                  />
                )}
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>URL Status</label>
                <SelectSearchField
                  value={state.urlStatus}
                  options={urlStatus}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  name='urlStatus'
                  isLoading={false}
                  loadingMessage='Featching Url status'
                  noOptionsMessage='Url status are not available.'
                  placeholder='Select Url status'
                  multiple={true}
                />
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>Industry</label>
                <SelectSearchField
                  value={state.industry}
                  options={industry}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  name='industry'
                  isLoading={false}
                  loadingMessage='Featching industry'
                  noOptionsMessage='Industry are not available.'
                  placeholder='Select industry'
                  multiple={true}
                />
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>Technology</label>
                <SelectSearchField
                  value={state.technology}
                  options={technology}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  name='technology'
                  isLoading={false}
                  loadingMessage='Featching technology'
                  noOptionsMessage='Technology are not available.'
                  placeholder='Select technology'
                  multiple={true}
                />
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>Framework</label>
                <SelectSearchField
                  value={state.framework}
                  options={framework}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  name='framework'
                  isLoading={false}
                  loadingMessage='Featching framework'
                  noOptionsMessage='Framework are not available.'
                  placeholder='Select framework'
                  multiple={true}
                />
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>Service</label>
                <SelectSearchField
                  value={state.service}
                  options={service}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  name='service'
                  isLoading={false}
                  loadingMessage='Featching service'
                  noOptionsMessage='Service are not available.'
                  placeholder='Select service'
                  multiple={true}
                />
              </div>
              <div className='col-12 col-md-6 col-lg-3  px-2 pb-3 '>
                <label className='fw-bold fs-6 mb-2'>NDA Protected</label>
                <SelectSearchField
                  value={state.eNDAProtected}
                  options={ndaProtected}
                  isSearchable={true}
                  handleOnChange={handleOnChange}
                  name='eNDAProtected'
                  isLoading={false}
                  loadingMessage='Featching NDA Protected'
                  noOptionsMessage='NDA Protected are not available.'
                  placeholder='Select NDA Protected'
                />
              </div>
              {/* Submission Button */}
              <div className={`col-md-12 text-center pt-5 px-2 d-flex justify-content-end`}>
                <button
                  disabled={isLoading && !initaialLoading}
                  type='button'
                  onClick={() => resetFilter()}
                  className='btn btn-secondary btn-sm me-3'
                  data-kt-menu-dismiss='true'
                  data-kt-user-table-filter='filter'
                >
                  <span className='indicator-label'>Reset</span>
                </button>
                {/* <button
                  type='submit'
                  className='btn btn-primary btn-sm me-3'
                  data-kt-users-modal-action='submit'
                  disabled={isLoading && !initaialLoading}
                  onClick={(e) => {
                    onSubmit(e)
                  }}
                >
                  <span className='indicator-label'>Search</span>
                </button> */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
